// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://thqmjjnphtsdcopzpcob.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRocW1qam5waHRzZGNvcHpwY29iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ2MDYyOTUsImV4cCI6MjA5MDE4MjI5NX0.K1xbPaG4QJvPo4C4fU9KD08bjRatxFiV_8m_h4IPQTY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
